import { Storage } from 'lib/Storage';
import { CustomError } from 'lib/Error';

export function initGlobals() {
    window.Log = CustomError();
    if (!window.TOTEM) {
        window.TOTEM = {} as any;
    }
    window.TOTEM.storage = new Storage();
}
